<script setup>
import CharacterEnlarge from '../kijk_live_qmusic_nl_default/text_animations/CharacterEnlarge.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const amount = computed(() => props.item.enrichment?.amount?.toLocaleString('nl-NL'))

const timelineTitle = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'MysterySoundAmount' }).add(timelineTitle, frames(25))
})
</script>

<template>
  <div
    :style="{
      left: item.properties.position.xCenter + 'px',
      top: item.properties.position.yTop + 'px',
      fontSize: item.properties.position.fontSize + 'px',
      color: item.properties.position.textColor,
    }"
    class="absolute -translate-x-1/2 tracking-[-14px] font-cervo text-white font-bold leading-none text-center drop-shadow-2xl"
  >
    <CharacterEnlarge :text="`€${amount}`" :wrap="false" @timeline="timelineTitle = $event" />
  </div>
</template>
